import React from "react";
import "./App.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { WaveCanvas, SiteNav, SiteFooter } from "./Home";
import AidanRoutine from "./Videos/AidanRoutineCottbus_2026";
const Photo1 =
  "/images/aidan-li-pommel-horse-2026-artistic-gymnastics-cottus-world-cup.png";
const Photo2 =
  "/images/aidan-li-and-wajdi-bouallegue-2026-artistic-gymnastics-cottus-world-cup.jpg";
const Photo3 =
  "/images/aidan-li-and-wajdi-bouallegue-2026-artistic-gymnastics-cottus-world-cup-3.jpg";
const Photo4 =
  "/images/aidan-li-and-wajdi-bouallegue-2026-artistic-gymnastics-cottus-world-cup-2.jpg";
const Photo5 =
  "/images/aidan-li-2026-artistic-gymnastics-cottus-world-cup-2.jpg";
const Photo6 =
  "/images/aidan-li-2026-artistic-gymnastics-cottus-world-cup-3.jpg";
const Photo7 = "/images/aidan-li-2026-artistic-gymnastics-cottus-world-cup.jpg";
const Photo8 =
  "/images/aidan-li-pommel-horse-2026-artistic-gymnastics-cottus-world-cup-2.jpg";
const Photo9 =
  "/images/aidan-li-pommel-horse-2026-artistic-gymnastics-cottus-world-cup-3.jpg";

export default function NewsCottbus2026() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          Olympic Wave | Aidan Li - 2026 Artistic Gymnastics Cottbus World Cup
        </title>
        <meta
          name="description"
          content="Full competition recap, performance results and photos of Aidan Li at the 2026 Artistic Gymnastics Cottbus World Cup."
        />
        <meta
          property="og:title"
          content="Aidan Li - 2026 Artistic Gymnastics Cottbus World Cup."
        />
        <meta
          property="og:description"
          content="See full competition recap and photos of Aidan Li at the 2026 Artistic Gymnastics Cottbus World Cup."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://olympicwave.ca/news/aidan-li-2026-artistic-gymnastics-cottbus-world-cup"
        />
      </Helmet>

      <WaveCanvas />
      <div className="ow-page">
        <SiteNav />

        <main className="ow-inner ow-article-inner">
          {/* Hero */}
          <div className="ow-article-hero">
            <img
              src={Photo4}
              alt="Aidan Li and Wajdi Bouallègue at the 2026 FIG Artistic Gymnastics Cottbus World Cup"
            />
            <div className="ow-article-hero-overlay">
              <Link to="/news" className="ow-article-back-link">
                <ArrowLeft size={15} strokeWidth={2} /> {t("back")}
              </Link>
              <div className="ow-article-title-wrap">
                <h1 className="ow-article-title">{t("aiden_cottbus")}</h1>
              </div>
            </div>
          </div>

          {/* Article body */}
          <div className="ow-article-body">
            {/* Row 1 — text left, tall image right */}
            <div className="ow-article-row">
              <div className="ow-article-text">
                <h2 className="ow-article-section-title">
                  {t("cottbus_title_1")}
                </h2>
                <p className="ow-article-p">{t("cottbus_text_1")}</p>
              </div>
              <div className="ow-article-img-wrap ow-img-tall">
                <img
                  src={Photo3}
                  alt="Aidan Li and Wajdi Bouallègue at the 2026 FIG Artistic Gymnastics Cottbus World Cup"
                />
              </div>
            </div>

            {/* Row 2 — full width centered image */}
            <div className="ow-article-row-full">
              <div className="ow-article-img-wrap ow-img-wide-tall">
                <img
                  src={Photo1}
                  alt="Aidan Li at the 2026 Artistic Gymnastics Cottbus World Cup"
                />
              </div>
              <div className="ow-article-text ow-text-center">
                <h2 className="ow-article-section-title">
                  {t("cottbus_title_2")}
                </h2>
                <p className="ow-article-p">{t("cottbus_text_2")}</p>
              </div>
            </div>

            {/* Row 3 — image left, text right */}
            <div className="ow-article-row">
              <div className="ow-article-img-wrap">
                <img
                  src={Photo2}
                  alt="Aidan Li and Wajdi Bouallègue at the 2026 Artistic Gymnastics Cottbus World Cup"
                />
              </div>
              <div className="ow-article-text">
                <h2 className="ow-article-section-title">
                  {t("cottbus_title_3")}
                </h2>
                <p className="ow-article-p">{t("cottbus_text_3")}</p>
              </div>
            </div>

            {/* Routine video */}
            <div className="ow-article-media-block">
              <h2
                className="ow-article-section-title-2"
                style={{ marginTop: "2rem" }}
              >
                {t("routine")}
              </h2>
              <AidanRoutine />
            </div>

            {/* Gallery */}
            <div className="ow-article-media-block">
              <h2 className="ow-article-section-title">{t("morephoto")}</h2>

              {/* Editorial grid: 1 large left + 2 stacked right + 2 bottom */}
              <div className="ow-gallery-editorial">
                <div className="ow-gallery-feat">
                  <img
                    src={Photo9}
                    alt="Aidan Li pommel horse final Cottbus 2026"
                  />
                </div>
                <div className="ow-gallery-stack-item">
                  <img src={Photo5} alt="Aidan Li close-up Cottbus 2026" />
                </div>
                <div className="ow-gallery-stack-item">
                  <img src={Photo8} alt="Aidan Li pommel horse Cottbus 2026" />
                </div>
                <div className="ow-gallery-bottom-left">
                  <img src={Photo6} alt="Aidan Li waiting Cottbus 2026" />
                </div>
                <div className="ow-gallery-bottom-right">
                  <img src={Photo7} alt="Aidan Li warming up at Cottbus 2026" />
                </div>
              </div>
            </div>
          </div>
        </main>

        <SiteFooter />
      </div>
    </>
  );
}
